import {
  EmptyInput,
  Errors,
  FlexColumnCss,
  InputGroup,
  InputGroupBreak,
  InputRow,
  ModelInput,
  ModelMultiSelect,
  ModelNewNumericInput,
  ModelSelect,
  RadioYesNoInput,
} from '@equifinance/shared';
import { css } from 'styled-components';
import Section from '../../components/Section';
import { HighlightInputGroup, HighlightInputGroupSecondary } from '../../components/HighlightInputGroup';
import { LoanDetails, LoanPurpose, RepaymentType } from '../../../../contexts/account/LoanDetails';

const multiSelectCss = css`${({ theme }) => `
  max-width: calc(50% - ${theme.padding[8]} * 2);
`}`;

export default function General({
  loanDetails,
  errors,
  warnings,
}: {
  loanDetails?: LoanDetails;
  errors: Errors;
  warnings: Errors;
}) {
  return (
    <Section
      id={loanDetails?.id}
      title="General"
      level={1}
      errors={errors}
      warnings={warnings}
      titleIcon={<></>}
    >
      <InputGroup>
        <InputRow>
          <ModelMultiSelect
            label="Loan purpose"
            field="loanDetails.loanPurpose"
            options={LoanPurpose}
            containerCss={multiSelectCss}
            required
          />
          { loanDetails?.loanPurpose?.includes(LoanPurpose?.Other) ? (
            <ModelInput
              label="Provide loan purpose details"
              field="loanDetails.loanPurposeDetails"
              required
            />
          ) : (
            <EmptyInput />
          )}

        </InputRow>
      </InputGroup>

      <HighlightInputGroupSecondary>
        <InputGroup>
          <InputRow>
            <ModelNewNumericInput
              label="Net loan amount"
              field="loanDetails.loanAmount"
              isFixedDecimal
              prefix="£"
              required
              maxCharacters={10}
            />
            <ModelNewNumericInput
              label="Term"
              field="loanDetails.term"
              suffix="months"
              required
              noGroupingSeperator
              integer
            />
          </InputRow>

        </InputGroup>
      </HighlightInputGroupSecondary>

      <InputGroup>
        <InputRow>
          <ModelSelect
            label="Repayment type"
            field="loanDetails.repaymentType"
            options={RepaymentType}
            disabled
            required
          />
          <EmptyInput />
        </InputRow>
      </InputGroup>

      <InputGroupBreak />

      <InputGroup>
        <InputRow>
          <RadioYesNoInput
            label={<>Is the Applicant an existing Equifinance customer?</>}
            field="loanDetails.isExistingCustomer"
            required
          />
          <EmptyInput />
        </InputRow>
      </InputGroup>

      {loanDetails?.isExistingCustomer && (
      <HighlightInputGroup>
        <InputGroup>
          <InputRow>
            <RadioYesNoInput
              label="How do you wish to proceed:"
              field="loanDetails.isConsolidateExistingLoan"
              yesLabelOverride="Consolidate the existing loan"
              noLabelOverride="Treat it as a separate loan"
              required
              disabled={loanDetails?.isConsolidateExistingLoan}
              containerStyle={FlexColumnCss}
            />

            {loanDetails?.isConsolidateExistingLoan === true && (
              <ModelNewNumericInput
                label="Estimated redemption amount"
                field="loanDetails.estimatedRedemptionAmount"
                prefix="£"
                tooltip="Estimated redemption amount, will be overridden when the credit search is run"
                isFixedDecimal
                required
              />
            )}

            {loanDetails?.isConsolidateExistingLoan === false && (
              <ModelNewNumericInput
                label="Outstanding current balance"
                field="loanDetails.outstandingCurrentBalance"
                prefix="£"
                isFixedDecimal
                required
              />
            )}
          </InputRow>
        </InputGroup>
      </HighlightInputGroup>
      )}

      <InputGroup>
        <InputRow>
          <ModelNewNumericInput
            label="Gross loan amount"
            field="loanDetails.grossLoanAmount"
            prefix="£"
            isFixedDecimal
            disabled
            required
            maxCharacters={10}
          />
          <EmptyInput />
        </InputRow>
      </InputGroup>
    </Section>
  );
}
